import { render, staticRenderFns } from "./RoundForm.vue?vue&type=template&id=6dca9e5e&scoped=true&"
import script from "./RoundForm.vue?vue&type=script&lang=js&"
export * from "./RoundForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca9e5e",
  null
  
)

export default component.exports